import { TVConfig } from '../../../../../../../../../store/planStore';

const getAggregatedTotals = (formData?: TVConfig) => {
  const aggregatedTotals: Record<
    number,
    { total: number; numberOfDays: number }
  > =
    formData?.grpTable?.weeks?.reduce((acc, week, index) => {
      const { weekNumber, numberOfDays } = week;
      const total = formData?.grpTable?.columnTotals?.[index] ?? 0;

      if (!acc[weekNumber]) {
        acc[weekNumber] = { total: 0, numberOfDays: 0 };
      }

      acc[weekNumber].total += total;
      acc[weekNumber].numberOfDays += numberOfDays;

      return acc;
    }, {} as Record<number, { total: number; numberOfDays: number }>) ?? {};

  const isInvalid = Object.values(aggregatedTotals).some(
    ({ total, numberOfDays }) => {
      const weeklyMax =
        ((formData?.weeklyWeight?.max ?? 100) / 7) * numberOfDays;
      const weeklyMin = ((formData?.weeklyWeight?.min ?? 0) / 7) * numberOfDays;

      return total > weeklyMax || total < weeklyMin;
    }
  );

  return isInvalid;
};

export default getAggregatedTotals;
